import { G } from '@mobily/ts-belt';
import { ValidationErrorsBIC, validateBIC } from 'ibantools';
import { TextInput, TextInputProps, Validator } from 'react-admin';
import { match } from 'ts-pattern';

const isValidBic = (value: string | undefined) => {
  if (G.isNullable(value)) {
    return;
  }
  const validationResult = validateBIC(value.replaceAll(' ', ''));

  if (!validationResult.valid) {
    return match(validationResult.errorCodes.at(0))
      .with(
        ValidationErrorsBIC.NoBICProvided,
        () => 'resources.bo_common.validation.bic.checksum_not_number',
      )
      .with(
        ValidationErrorsBIC.NoBICCountry,
        () => 'resources.bo_common.validation.bic.no_bic_country',
      )
      .with(
        ValidationErrorsBIC.WrongBICFormat,
        () => 'resources.bo_common.validation.bic.wrong_bic_format',
      )
      .otherwise(() => 'resources.bo_common.validation.bic.wrong_bic_format');
  }
};

type BicInputProps = TextInputProps & { testId?: string };

export const BicInput = ({ validate, testId, ...props }: BicInputProps) => {
  const validators: Validator[] = [isValidBic];

  if (validate) {
    validators.push(...(Array.isArray(validate) ? validate : [validate]));
  }

  return <TextInput {...props} data-testid={testId} validate={validators} />;
};
